/* src/pages/StageMode/CreateStageCardWrapper.tsx */
import React from "react";
import { useNavigate } from "react-router-dom";
import CreateStageCardForm from "./CreateStageCard";

const CreateStageCardWrapper: React.FC = () => {
  const navigate = useNavigate();

  // centralised success handler → redirect or toast
  const handleSuccess = (card: { id: string }) => {
    // e.g. push user straight into the Stage-Mode preview page
    navigate(`/featured-event/${card.id}`, { replace: true });
  };

  return <CreateStageCardForm onSuccess={handleSuccess} />;
};

export default CreateStageCardWrapper;
